import React, { useEffect } from 'react';

import Navbar from '../../Components/Gallium/navbar';
import Footer from '../../Components/Gallium/footer';
import Hero from './hero';
import NonAuthLayout from '../../Layouts/NonAuthLayout';
import Console from './console';
import Templates from './templates';
import ServiceGateway from './servicegateway';
import Hypervisor from './hypervisor';
import EmailCollection from './emailCollection';

import { graphql } from "gatsby"
import { StoryblokStory } from "gatsby-source-storyblok"




const Index = ({ data }) => {
    
    useEffect(() => {
        document.title =" Gallium | Product Tour";

        
    },[])

    if (typeof data.storyblokEntry.content === "string") data.storyblokEntry.content = JSON.parse(data.storyblokEntry.content);
    return (
        <React.Fragment>
            <NonAuthLayout>          
                <div className="layout-wrapper landing">
                    <Navbar />
                    <Hero />
                    <Hypervisor />
                    <Console />
                    <Templates />
                    <ServiceGateway />
                    <EmailCollection />
                    <StoryblokStory story={data.storyblokEntry} />
                    {/* <Cta /> */}
                    <Footer />
                    <button onClick={() => toTop()} className="btn btn-danger btn-icon landing-back-top" id="back-to-top">
                        <i className="ri-arrow-up-line"></i>
                    </button>
                </div>
            </NonAuthLayout>  
        </React.Fragment>
    );
};

export default Index;

export const query = graphql`
  query HomeQuery {
    storyblokEntry(full_slug: { eq: "Tour" }) {
      content
      name
      full_slug
      uuid
      id
      internalId
    }
  }
`
